import {decorate, inject, injectable} from '@yosmanyga/di';
import {AxiosInstance} from './Axios';

class DeviceApi {
    constructor(private axios: AxiosInstance) {
    }

    validateDevice = async (id: string): Promise<boolean> => {
        const {data}: { data: boolean } = await this.axios.post('/v1/validate-device', {
            id: id,
        });

        return data as boolean;
    }

    addDevice = async (payload: object): Promise<string> => {
        const {data}: { data: string } = await this.axios.post('/v1/add-device', {
            payload: payload,
        });

        return data;
    };
}

decorate(injectable(), DeviceApi);
decorate(inject(AxiosInstance), DeviceApi, 0);

export {DeviceApi};
